import { TEntityType, TPublicationStatus } from 'src/types/menu.types';

export const EVENT_TYPES = {
  DUPLICATE: 'DUPLICATE',
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
  PUBLISH_PRICING: 'PUBLISH_PRICING',
  PUBLISH_PRODUCT: 'PUBLISH_PRODUCT',
  PUBLISH: 'PUBLISH',
  PUBLISH_MENU: 'PUBLISH_MENU',
  PUBLISH_TIMETABLE: 'PUBLISH_TIMETABLE',
  PUBLISH_MENU_SET: 'PUBLISH_MENU_SET',
} as const;

export type EventType = keyof typeof EVENT_TYPES;
export type LogStatus = TPublicationStatus;

export const EVENT_STATUSES = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  PENDING: 'PENDING',
  PARTIAL_SUCCESS: 'PARTIAL_SUCCESS',
  UNPUBLISHED: 'UNPUBLISHED',
  SENT: 'SENT',
  CANCELLED: 'CANCELLED',
  SCHEDULED: 'SCHEDULED',
  REJECTED: 'REJECTED',
  UNTRACKED: 'UNTRACKED',
} as const satisfies Record<string, LogStatus>;

export const ENTITY_TYPES = {
  PRODUCT: 'PRODUCT',
  MENU: 'MENU',
  PRICE_SCHEME: 'PRICE_SCHEME',
  VENUE: 'VENUE',
  EXTERNAL_SYSTEM: 'EXTERNAL_SYSTEM',
  TIMETABLE: 'TIMETABLE',
  MENU_SET: 'MENU_SET',
} as const;

export interface IEvent {
  event_id: string;
  entity_type: TEntityType | null;
  entity_id: string | null;
  entity_name?: string | null;
  event_type: EventType;
  status: LogStatus;
  message: string;
  objects: unknown[];
  updated_at: string;
  created_at?: string;
  child_events: IEvent[] | null;
}

export interface IGetEventsParams {
  entity_type?: TEntityType;
  entity_id?: string;
  event_type?: EventType;
  status?: LogStatus;
}

export interface IEventsResponseBody {
  type: string;
  data: IEvent[];
}
